//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.Industry.SelectProjectLoadFromBuilder.js";
import "../no/Features.js";
let d=[[[0,"IsNewStructure",1,0],[0,"IsSaveAsSharePart",1,0],[0,"KeepFramebarEnabled",1,0],[1,"ProjectLoadFromBuilder",0,"Features.Industry.SelectProjectLoadFromBuilder",0],[0,"ProjectName",1,0],[0,"RepositoryPart",1,"Part",0],[0,"RootPart",1,"Part",0]],[[["parts"],"AddSharedParts",{},1,0],[[],"GetRootNode",{R_:{rootNode:"Features.ShipDesign.ProjectStructureNode"}},0,1],[[],"GetProjectRootNode",{R_:{rootNode:"Features.Industry.ProjectStructureNode"}},0,0],[["hullTemplateID"],"SetHullTemplateIdentifier",{},1,0]],[]];
SPLM.Features.ShipDesign.ProjectSetupBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ProjectSetupBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;